var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFolderFade = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 6.85676C18 5.75219 17.1046 4.85676 16 4.85676H10.8929C10.043 4.85676 9.286 4.31968 9.00521 3.51754L8.94279 3.33922C8.66201 2.53709 7.90496 2 7.0551 2H4C2.89543 2 2 2.89543 2 4V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V6.85676Z",
  fill: "#15154A",
  fillOpacity: 0.06
})));
export { SvgFolderFade as ReactComponent };